import Repository from "./Repository";

const CREATE_HOME_BANNER = "/create";
const EDIT_HOME_BANNER = "/update";
const GET_ALL_HOME_BANNER = "/getall";
const DELETE_HOME_BANNER = "/delete";

export default {
  create(payload) {
    return Repository.post(transformRoute(CREATE_HOME_BANNER), payload);
  },
  update(payload) {
    return Repository.post(transformRoute(EDIT_HOME_BANNER), payload);
  },
  getAll(payload) {
    return Repository.get(transformRoute(GET_ALL_HOME_BANNER), {
      params: payload,
    });
  },
  delete(payload) {
    return Repository.post(transformRoute(DELETE_HOME_BANNER), payload);
  },
};
const transformRoute = (route) => {
  return `/homePageBanner${route}`;
};
